import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererProductTemplateApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.createProductPageTemplate = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/products/page_templates`, requestBody);
        };
        this.updateProductPageTemplate = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/products/page_templates/${pathParams.product_page_template_id}`, requestBody);
        };
        this.getTemplateOffersDetails = (pathParams, queryParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/products/page_templates/${pathParams.product_page_template_id}/offers`, queryParams);
        };
        this.addOffersToProductPageTemplate = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/products/page_templates/${pathParams.product_page_template_id}/offers`, requestBody);
        };
        this.deleteProductPageTemplate = (pathParams) => {
            return this.delete(`/shops/${pathParams.shop_id}/products/page_templates/${pathParams.product_page_template_id}`);
        };
        this.createCollectionPageTemplate = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/collections/page_templates`, requestBody);
        };
        this.deleteCollectionPageTemplate = (pathParams) => {
            return this.delete(`/shops/${pathParams.shop_id}/collections/page_templates/${pathParams.collection_page_template_id}`);
        };
        this.updateCollectionPageTemplate = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/collections/page_templates/${pathParams.collection_page_template_id}`, requestBody);
        };
        this.addCollectionsToCollectionPageTemplate = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/collections/page_templates/${pathParams.collection_page_template_id}/collections`, requestBody);
        };
        this.getCollectionTemplateDetails = (pathParams, queryParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/collections/page_templates/${pathParams.collection_page_template_id}/collections`, queryParams);
        };
    }
}
export const ShopRendererProductTemplateApiClient = new ShopRendererProductTemplateApiClientModel(getShopRendererApiUrl('api'));
